const CHECKOUT_BUTTON_SELECTOR = 'a.Button.Button--primary[href="/checkout"]';

function initializeWidget() {
  window.localStorage.setItem(
    "com.shield:checkoutButtonSelector",
    CHECKOUT_BUTTON_SELECTOR
  );

  const checkoutButton = document.querySelector(CHECKOUT_BUTTON_SELECTOR);

  if (checkoutButton && !document.querySelector("shield-widget")) {
    console.log("initializing widget creating element");
    const shieldWidget = document.createElement("shield-widget");
    checkoutButton.parentNode.insertBefore(shieldWidget, checkoutButton);
  }
}

// Create a mutation observer to watch for DOM changes
const observer = new MutationObserver(() => {
  initializeWidget();
});

// Start observing the entire document for changes
observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// Initial check in case the button is already present
initializeWidget();

document.addEventListener("minicart:refreshed", () => {
  initializeWidget();
});

console.log("shieldjs");

// Fling override: swap Shield branding for Fling logo + copy (config in theme.liquid)
function applyFlingOverride() {
  const cfg = window.shieldFlingOverride;
  if (!cfg) return;
  const widget = document.querySelector("shield-widget");
  if (!widget) return;
  const logo = widget.querySelector("#logo");
  if (logo && cfg.logo && logo.getAttribute("src") !== cfg.logo) {
    logo.setAttribute("src", cfg.logo);
    logo.setAttribute("alt", cfg.title || "Package Protection");
  }
  const title = widget.querySelector("#shield-title");
  if (title && cfg.title && !title.querySelector(".skeleton-box") && title.textContent !== cfg.title) {
    title.textContent = cfg.title;
  }
  const subtitle = widget.querySelector("#shield-subtitle");
  if (subtitle && cfg.subtitle && subtitle.textContent.trim() && subtitle.textContent !== cfg.subtitle) {
    subtitle.textContent = cfg.subtitle;
  }
}

new MutationObserver(applyFlingOverride).observe(document.body, {
  childList: true,
  subtree: true,
  characterData: true,
});
applyFlingOverride();

// Fling fallback: Shield's backend variant registry is empty for this store,
// so its own checkout handler can't add the protection item. We own the
// checkout click instead and reconcile the cart with the widget toggle.
const SHIELD_PRODUCT_ID = 9495806640359;
const SHIELD_VARIANT_2USD = 51921554145511; // $2.00 variant

document.addEventListener(
  "click",
  (e) => {
    const btn = e.target.closest(CHECKOUT_BUTTON_SELECTOR);
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    (async () => {
      try {
        const enabled = window.localStorage.getItem("com.shield:cart_enabled") === "true";
        const cart = await (await fetch("/cart.js")).json();
        const item = cart.items.find((i) => i.product_id === SHIELD_PRODUCT_ID);
        if (enabled && !item) {
          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({ id: SHIELD_VARIANT_2USD, quantity: 1 }),
          });
        } else if (!enabled && item) {
          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({ updates: { [item.key]: 0 } }),
          });
        }
      } catch (err) {
        console.error("fling shield fallback", err);
      }
      window.location.href = "/checkout";
    })();
  },
  true
);
